export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/whoops-6d4a5fab1c31d64609c17aec17b03fad.svg";